import { lazy, Suspense } from "react";
import { DialogsContext } from "../contexts";
import { useDialogs } from "./dialog.util";
import TermDialog from "../term/term.dialog";

const SearchDialog = lazy(() => import('../app/search.dialog'));
const CourseDialog = lazy(() => import('../course/course.dialog'));
const CourseDetailDialog = lazy(() => import('../course/courseDetail.dialog'));
const CourseDetailWizard = lazy(() => import('../course/courseDetail.wizard'));
const ActivityCompletePreviousDialog = lazy(() => import('../enrollment/activityCompletePrevious.dialog'));
const ActivityRescheduleDialog = lazy(() => import('../enrollment/activityReschedule.dialog'));
const ActivityUnscheduleDialog = lazy(() => import('../enrollment/activityUnschedule.dialog'));
const EnrollmentDialog = lazy(() => import('../enrollment/enrollment.dialog'));
const EnrollmentCompleteDialog = lazy(() => import('../enrollment/enrollmentComplete.dialog'));
const EnrollmentRescheduleDialog = lazy(() => import('../enrollment/enrollmentReschedule.dialog'));
const EnrollmentReschedulePromptDialog = lazy(() => import('../enrollment/enrollmentReschedulePrompt.dialog'));
const EnrollmentUnenrollDialog = lazy(() => import('../enrollment/enrollmentUnenroll.dialog'));
const EnrollmentUnscheduleDialog = lazy(() => import('../enrollment/enrollmentUnschedule.dialog'));
const HolidayDialog = lazy(() => import('../holiday/holiday.dialog'));
const StudentDialog = lazy(() => import('../student/student.dialog'));
const SubjectDialog = lazy(() => import('../subject/subject.dialog'));

export default function DialogsProvider({ children }) {
	const dialogs = useDialogs();

	const close = (dialog) => {
		dialogs.close(dialog);
	}

	return (
		<DialogsContext.Provider value={{ dialogs }}>
			{children}

			<Suspense fallback={null}>
				<ActivityCompletePreviousDialog activities={dialogs.data} open={dialogs.isOpen?.activityCompletePrevious == true} onSubmit={() => close('activityCompletePrevious')} onCancel={() => close('activityCompletePrevious')} />
			</Suspense>
			<Suspense fallback={null}>
				<ActivityRescheduleDialog activities={dialogs.data} open={dialogs.isOpen?.activityReschedule == true} onSubmit={() => close('activityReschedule')} onCancel={() => close('activityReschedule')} />
			</Suspense>
			<Suspense fallback={null}>
				<ActivityUnscheduleDialog activities={dialogs.data} open={dialogs.isOpen?.activityUnschedule == true} onSubmit={() => close('activityUnschedule')} onCancel={() => close('activityUnschedule')} />
			</Suspense>

			<Suspense fallback={null}>
				<CourseDialog course={dialogs.data} open={dialogs.isOpen?.course == true} onSubmit={() => close('course')} onCancel={() => close('course')} />
			</Suspense>
			<Suspense fallback={null}>
				<CourseDetailDialog courseDetail={dialogs.data} open={dialogs.isOpen?.courseDetail == true} onSubmit={() => close('courseDetail')} onCancel={() => close('courseDetail')} />
			</Suspense>
			<Suspense fallback={null}>
				<CourseDetailWizard courseDetail={dialogs.data} open={dialogs.isOpen?.courseDetailWizard == true} onSubmit={() => close('courseDetailWizard')} onCancel={() => close('courseDetailWizard')} />
			</Suspense>

			<Suspense fallback={null}>
				<EnrollmentDialog enrollment={dialogs.data} open={dialogs.isOpen?.enrollment == true} onSubmit={() => close('enrollment')} onCancel={() => close('enrollment')} />
			</Suspense>
			<Suspense fallback={null}>
				<EnrollmentCompleteDialog enrollment={dialogs.data} open={dialogs.isOpen?.enrollmentComplete == true} onSubmit={() => close('enrollmentComplete')} onCancel={() => close('enrollmentComplete')} />
			</Suspense>
			<Suspense fallback={null}>
				<EnrollmentRescheduleDialog enrollment={dialogs.data} open={dialogs.isOpen?.enrollmentReschedule == true} onSubmit={() => close('enrollmentReschedule')} onCancel={() => close('enrollmentReschedule')} />
			</Suspense>
			<Suspense fallback={null}>
				<EnrollmentReschedulePromptDialog enrollmentId={dialogs.data} open={dialogs.isOpen?.enrollmentReschedulePrompt == true} onSubmit={() => close('enrollmentReschedulePrompt')} onCancel={() => close('enrollmentReschedulePrompt')} />
			</Suspense>
			<Suspense fallback={null}>
				<EnrollmentUnscheduleDialog enrollment={dialogs.data} open={dialogs.isOpen?.enrollmentUnschedule == true} onSubmit={() => close('enrollmentUnschedule')} onCancel={() => close('enrollmentUnschedule')} />
			</Suspense>
			<Suspense fallback={null}>
				<EnrollmentUnenrollDialog enrollment={dialogs.data} open={dialogs.isOpen?.enrollmentUnenroll == true} onSubmit={() => close('enrollmentUnenroll')} onCancel={() => close('enrollmentUnenroll')} />
			</Suspense>
			<Suspense fallback={null}>
				{/* <EnrollmentWizard enrollment={dialog.data} open={dialog.isOpen} onSubmit={(result) => dialog.onSubmit(result)} onCancel={() => dialog.close()} /> */}
			</Suspense>

			<Suspense fallback={null}>
				<HolidayDialog holiday={dialogs.data} open={dialogs.isOpen?.holiday == true} onSubmit={() => close('holiday')} onCancel={() => close('holiday')} />
			</Suspense>

			<Suspense fallback={null}>
				<SearchDialog open={dialogs.isOpen?.search == true} onSubmit={() => close('search')} onCancel={() => close('search')} />
			</Suspense>

			<Suspense fallback={null}>
				<StudentDialog student={dialogs.data} open={dialogs.isOpen?.student == true} onSubmit={() => close('student')} onCancel={() => close('student')} />
			</Suspense>

			<Suspense fallback={null}>
				<SubjectDialog subject={dialogs.data} open={dialogs.isOpen?.subject == true} onSubmit={() => close('subject')} onCancel={() => close('subject')} />
			</Suspense>

			<Suspense fallback={null}>
				<TermDialog term={dialogs.data} open={dialogs.isOpen?.term == true} onSubmit={() => close('term')} onCancel={() => close('term')} />
			</Suspense>
		</DialogsContext.Provider>
	);
}
